import { isShallowEqual } from "@suse-o11y/is-shallow-equal";
import { FormUnit, type Result } from "@suse-o11y/signal/form";
import { tryCatch } from "@suse-o11y/try-catch";
import { parse, stringify } from "yaml";

import { DashboardSpec } from "../../common/dashboard-spec";

export type FormState = FormUnit<string, null | ReadonlyArray<string>, DashboardSpec>;

export function init(spec: DashboardSpec): FormState {
	const yaml = stringify(spec.toPerses());

	return FormUnit(yaml, {
		isErrorEqual: isShallowEqual,
		validate: (input): Result<null | ReadonlyArray<string>, DashboardSpec> => {
			const [, json] = tryCatch((): unknown => parse(input));

			const result = DashboardSpec.schema.safeParse(json);

			if (result.success) {
				return [null, result.data];
			}

			return [result.error.errors.map(({ message, path }) => `${path.join(".")}: ${message}`), null];
		},
	});
}
